import * as React from "react"
import ShareOfVoice from "../../svgs/components/minimalist-pages/share-of-voice"
import PrioritizedKeywordList from "../../svgs/components/minimalist-pages/prioritized-keyword-list"
import ItemSearchScorecard from "../../svgs/components/minimalist-pages/item-search-scorecard"
import SearchSnapshot from "../../svgs/components/minimalist-pages/search-snapshot"
import ShareOfDigitalShelf from "../../svgs/components/minimalist-pages/share-of-digital-shelf"

const OptimizeSearchTools = (props) => (
    <div id="optimize-search-carousel" className="carousel slide carousel-fade w-100" data-bs-ride="carousel">
        <div className="carousel-inner w-100">
            <div className="carousel-item active  w-100 d-flex justify-content-center">
                <ShareOfVoice className='w-80 tool-abstraction'/>
            </div>
            <div className="carousel-item  w-100 d-flex justify-content-center">
                <PrioritizedKeywordList className='w-80 tool-abstraction'/>
            </div>
            <div className="carousel-item  w-100 d-flex justify-content-center">
                <ItemSearchScorecard className='w-80 tool-abstraction'/>
            </div>
            <div className="carousel-item  w-100 d-flex justify-content-center">
                <SearchSnapshot className='w-80 tool-abstraction'/>
            </div>
            <div className="carousel-item  w-100 d-flex justify-content-center">
                <ShareOfDigitalShelf className='w-80 tool-abstraction'/>
            </div>
        </div>
    </div>
)

export default OptimizeSearchTools;
